// extracted by mini-css-extract-plugin
module.exports = {"container":"collection_container__j1RRj","contract_detail_container":"collection_contract_detail_container__90hQU","is_center":"collection_is_center__cBsKP"};